// extracted by mini-css-extract-plugin
export default {"formGroup":"_1Vqd-","validationMessage":"_2AQK2","errorBox":"_1NJ5d"};